var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.969 5.574a.484.484 0 010 .664c-.196.196-.489.196-.664 0L4 3.914 1.676 6.238c-.196.196-.488.196-.664 0-.196-.176-.196-.468 0-.664L3.336 3.25 1.012.926C.816.73.816.437 1.012.262a.428.428 0 01.644 0L4 2.605 6.324.281a.428.428 0 01.645 0c.195.176.195.469 0 .664L4.645 3.25l2.324 2.324z"
  })));
}
export default SvgCloseIcon;